import apiService from '../utils/apiInterceptor';
import config from '../config';

/**
 * Service for handling notifications
 */
const notificationService = {
  /**
   * Get recent notifications for the current user
   * @param {number} limit - Number of notifications to retrieve (default: 5)
   * @returns {Promise<Object>} Notifications data
   */
  getRecentNotifications: async (limit = 5) => {
    try {
      const response = await apiService.get('/notifications/recent', {
        params: { limit }
      });
      return response;
    } catch (error) {
      console.error('Error fetching recent notifications:', error);
      throw error;
    }
  },

  /**
   * Get all notifications with pagination and filters
   * @param {Object} params - Filter and pagination parameters
   * @returns {Promise<Object>} Notifications data
   */
  getNotifications: async (params = {}) => {
    try {
      const response = await apiService.get('/notifications', { params });
      return response;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  /**
   * Mark a notification as read
   * @param {number} notificationId - Notification ID
   * @returns {Promise<Object>} Response data
   */
  markAsRead: async (notificationId) => {
    try {
      const response = await apiService.post(`/notifications/${notificationId}/read`);
      return response;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  /**
   * Mark all notifications as read
   * @returns {Promise<Object>} Response data
   */
  markAllAsRead: async () => {
    try {
      const response = await apiService.post('/notifications/read-all');
      return response;
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  },

  /**
   * Delete a notification
   * @param {number} notificationId - Notification ID
   * @returns {Promise<Object>} Response data
   */
  deleteNotification: async (notificationId) => {
    try {
      const response = await apiService.delete(`/notifications/${notificationId}`);
      return response;
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  },

  /**
   * Create a system notification
   * @param {Object} data - Notification data
   * @returns {Promise<Object>} Response data
   */
  createNotification: async (data) => {
    try {
      const response = await apiService.post('/admin/notifications', data);
      return response;
    } catch (error) {
      console.error('Error creating notification:', error);
      throw error;
    }
  },

  /**
   * Get unread notifications count
   * @returns {Promise<Object>} Response data with count
   */
  getUnreadCount: async () => {
    try {
      const response = await apiService.get('/notifications/unread-count');
      return response;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  }
};

export default notificationService;